import { PATH_API } from "constants/api";
import { ApiResponse } from "interfaces/models/api";
import { axiosECS } from "services/baseAxios";
import { View } from "../forgeApi";

const path = PATH_API.BIM_VIEW;

// Get a list of views that have been generated on the database
export const getGeneratedViewList = async (
  bimFileId: string, // bim file with version
  shouldCache?: boolean
): Promise<ApiResponse<any[]>> => {
  const response = await axiosECS.get(path, {
    params: { bimFileId, shouldCache },
  });

  return response;
};

// Get a list of combined views: data from aps + data bim file (levelData)
export const getCombinedViewList = async (
  projectId: string,
  bimFileId: string, // bim file id with version (encodeURIComponent format)
  shouldCache?: boolean
): Promise<ApiResponse<View[]>> => {
  return axiosECS.get(`${path}/combined-views`, {
    params: { projectId, bimFileId, shouldCache },
  });
};

export const createBimViewList = async (body: {
  bimFileId: string; // bim file with version
  views: any[];
}): Promise<ApiResponse<any[]>> => {
  return axiosECS.post(path, body);
};

export const deleteBimViewByBimFile = async (
  bimFileId: string
): Promise<ApiResponse<any[]>> => {
  return axiosECS.delete(path, {
    data: { bimFileId },
  });
};
